import { SHARED, STANDALONE } from '../utils/constants'

export const getters = {
  isShared: () => process.env.appType === SHARED,
  isStandalone: () => process.env.appType === STANDALONE,
}
